<template>
      <div id="livehealth-online">
            <section class="section livehealth-hero animate__animated animate__fadeIn">
                  <BackButton link="/sydney-health" />
                  <div class="grid-container max">
                        <div class="livehealth-grid">
                              <div class="livehealth-left">
                                    <h1>LiveHealth<br />Online</h1>
                              </div>
                              <div class="livehealth-right">
                                    <p class="livehealth-heading">Healthcare needs don&rsquo;t always coincide with working hours</p>
                                    <p class="livehealth-desc">LiveHealth Online allows you to speak with a doctor or health professional from the comfort of your home or the convenience of your office. Out-of-pocket expenses will depend on the type of Plan Option you select.</p>
                                    <div class="livehealth-features">
                                          <div class="livehealth-feature">
                                                <img src="~@/assets/img/clock-new-icon.svg" alt="" />
                                                <p><strong>See</strong> a board-certified medical doctor in a few minutes without an appointment, 24/7.</p>
                                          </div>
                                          <div class="livehealth-feature">
                                                <img src="~@/assets/img/wifi-blue-icon.svg" alt="" />
                                                <p><strong>Connect</strong> with a licensed therapist quickly, within your network.</p>
                                          </div>
                                          <div class="livehealth-feature">
                                                <img src="~@/assets/img/brain-blue-icon.svg" alt="" />
                                                <p><strong>Visit</strong> with a licensed therapist, psychologist or psychiatrist from the privacy of your own home.<sup>1</sup></p>
                                          </div>
                                    </div>
                                    <div class="livehealth-box">
                                          <div class="livehealth-box-top">
                                                <div class="livehealth-box-icon">
                                                      <img src="~@/assets/img/livehealth-online-icon.svg" alt="" />
                                                </div>
                                                <p class="livehealth-box-signup"><a href="https://www.anthem.com/login/" target="_blank" @click="track('Link', 'Sign Up - Live Health Online')">Sign up</a> or <a href="https://www.anthem.com/login/" target="_blank" @click="track('Link', 'Log In - Live Health Online')">log in</a> to the Sydney<sup>SM</sup> Health app and <strong>select Virtual Care</strong> to start a visit.</p>
                                          </div>
                                          <p class="livehealth-box-doctors">Doctors can answer questions, make diagnoses and even prescribe basic medications when needed.<sup>2</sup> Visit <a href="https://Livehealthonline.com" target="_blank" @click="track('Link', 'Livehealthonline.com - Live Health Online')">Livehealthonline.com</a> for more information.</p>
                                    </div>
                              </div>
                        </div>
                        <p class="livehealth-footnote">1. LiveHealth Online Psychology appointments are available 7 days a week, 7 a.m. to 11 p.m. coast-to-coast, for adults and children age 10 or older. Psychiatrist appointments are subject to availability.<br />2. Prescription availability is defined by physician judgment and state regulations.</p>
                  </div>
            </section>
            <div class="livehealth-btn-wrap">
                  <router-link to="/therapist" class="livehealth-btn"><span>Next</span></router-link>
            </div>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPLiveHealthOnline",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#livehealth-online {
      .livehealth-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 160px 0;
            position: relative;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .livehealth-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 64px;
                  margin-top: 48px;
            }

            .livehealth-left {
                  flex: 1 1 360px;
                  max-width: 480px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 4.5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }
            }

            .livehealth-right {
                  flex: 2 1 640px;
                  max-width: 820px;

                  .livehealth-heading {
                        color: #012E58;
                        font-size: 1.375rem;
                        font-weight: 600;
                        line-height: 1.4;
                        margin-bottom: 20px;
                  }

                  .livehealth-desc {
                        color: #3F3A4E;
                        font-size: 1rem;
                        line-height: 1.6;
                        margin-bottom: 32px;
                  }
            }

            .livehealth-features {
                  display: grid;
                  grid-template-columns: repeat(3, 1fr);
                  gap: 32px;
                  margin-bottom: 32px;
            }

            .livehealth-feature {
                  img {
                        display: block;
                        width: 40px;
                        height: 40px;
                        object-fit: contain;
                        margin-bottom: 12px;
                  }

                  p {
                        color: #3F3A4E;
                        font-size: 0.9375rem;
                        line-height: 1.5;
                        margin-bottom: 0;

                        strong {
                              color: #1355E9;
                              font-weight: 700;
                        }
                  }
            }

            .livehealth-box {
                  background-color: #0A2C4C;
                  padding: 40px;
            }

            .livehealth-box-top {
                  display: flex;
                  align-items: center;
                  gap: 24px;
                  margin-bottom: 32px;
            }

            .livehealth-box-icon {
                  flex-shrink: 0;

                  img {
                        display: block;
                        width: 72px;
                        height: 72px;
                  }
            }

            .livehealth-box-signup {
                  color: #ffffff;
                  font-size: 1rem;
                  line-height: 1.6;
                  margin-bottom: 0;

                  a {
                        color: #ffffff !important;
                        font-weight: 700;
                        text-decoration: underline;
                  }
            }

            .livehealth-box-doctors {
                  color: rgba(255, 255, 255, 0.9);
                  font-size: 0.9375rem;
                  line-height: 1.6;
                  margin-bottom: 0;

                  a {
                        color: #ffffff !important;
                        font-weight: 700;
                        text-decoration: underline;
                  }
            }

            .livehealth-footnote {
                  color: #6b6b6b;
                  font-size: 0.75rem;
                  line-height: 1.6;
                  margin-top: 48px;
                  margin-bottom: 0;
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 140px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .livehealth-grid {
                        flex-direction: column;
                        gap: 32px;
                        margin-top: 32px;
                  }

                  .livehealth-left {
                        flex: 0 0 auto;
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 8vw, 3rem) !important;
                        }
                  }

                  .livehealth-right {
                        flex: 0 0 auto;
                        max-width: 100%;
                  }

                  .livehealth-features {
                        grid-template-columns: 1fr;
                        gap: 24px;
                  }

                  .livehealth-box {
                        padding: 32px 24px;
                  }

                  .livehealth-box-top {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 16px;
                  }
            }
      }

      .livehealth-btn-wrap {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 3;
            background-color: #ffffff;
            box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
            padding: 20px 0;
            text-align: center;
      }

      .livehealth-btn {
            display: block;
            background-color: #1355E9;
            color: #ffffff !important;
            font-weight: 700;
            text-transform: uppercase;
            font-size: 1rem;
            padding: 18px 0;
            width: 100%;
            max-width: 330px;
            text-align: center;
            border-radius: 30px;
            border: none;
            cursor: pointer;
            margin: 0 auto;

            &:hover {
                  background-color: #44B8F3;
            }
      }
}
</style>
